import { Component, inject, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import {
  _UI_IMAGE_UPLOAD,
  _UI_LOADING_STATE,
} from '../../data/store/ui/ui.selectors';
// import { selectUILoading, selectUIParams } from '../data/store/ui/ui.selectors';
@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.sass',
})
export class LoaderComponent implements OnDestroy {
  private readonly subscriptions: Subscription[] = [];
  public isLoading = false;
  public isImageUpload = false;
  private readonly store = inject(Store);

  constructor() {
    this.subscriptions.push(
      this.store
        .select(_UI_LOADING_STATE)
        .subscribe(loading => (this.isLoading = loading))
    );
    this.subscriptions.push(
      this.store
        .select(_UI_IMAGE_UPLOAD)
        .subscribe(loading => (this.isImageUpload = loading ?? false))
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
